import { Problem } from '../types';
import { TransportMode } from '../transport/types';

import { getToken } from '~services/auth';

export type Config = {
  baseUrl: string;
  /**
   * Reads the current user transport preference. Injected (rather than importing
   * the Redux store) so `cqrs/client` stays free of app-state dependencies —
   * matching how it only reaches out to `getToken`. Defaults to `'auto'`.
   */
  getTransportMode?: () => TransportMode;
  /**
   * SignalR hub URL for the generic graph transport. This is the shared One hub
   * (`${API_URL}/hub/v1`) — the same one the legacy device events use — NOT a
   * separate `/hub/graph` path. Only `OneService` uses it; provider APIs are
   * plain HTTP. Injected by `oneService.ts`.
   */
  graphHubUrl?: string;
};

export class BaseAPI {
  protected config: Config;

  protected _toProblem(error: any): Problem {
    const problem: Problem = {
      type: 'Problem',
      errorType: error.type,
      title: error.title,
      status: error.status,
      detail: error.detail,
      instance: error.instance,
    };
    return problem;
  }

  protected async getAccessToken(): Promise<string> {
    const token = await getToken();
    return token;
  }

  constructor(config: Config) {
    this.config = config;
  }
}
